import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTrash,
  faPenToSquare,
  faCircleCheck,
  faCartShopping,
  faEye,
  faEyeSlash,
  faPlus,
  faXmark,
  faPersonRays,
  faToggleOn,
  faToggleOff,
  faCalendarDays,
  faThumbsUp,
  faArrowRight,
  faTableCells,
  faClock,
  faUser,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';

// Central icon registry so components can import from a single place.
export const ICONS = {
  trash: faTrash,
  edit: faPenToSquare,
  validation: faCircleCheck,
  cart: faCartShopping,
  eye: faEye,
  eyeSlash: faEyeSlash,
  plus: faPlus,
  close: faXmark,
  adminInput: faPersonRays,
  toggleOn: faToggleOn,
  toggleOff: faToggleOff,
  calendar: faCalendarDays,
  thumbsUp: faThumbsUp,
  arrowRight: faArrowRight,
  table: faTableCells,
  clock: faClock,
  person: faUser,
  peopleGroup: faUsers,
};

library.add(...Object.values(ICONS));
